import { render } from "./Control.vue?vue&type=template&id=5dc4b072&scoped=true&ts=true&lang=pug"
import script from "./Control.vue?vue&type=script&lang=ts"
export * from "./Control.vue?vue&type=script&lang=ts"

import "./Control.vue?vue&type=style&index=0&id=5dc4b072&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc4b072"]])

export default __exports__